import { loadable } from '@fiverr-private/perseus';

const SourcingCard = loadable(() => import(/* webpackChunkName: "SourcingCard" */ './SourcingCard'));

export const SOURCING_CARD_CONFIG = {
    components: [
        {
            component: SourcingCard,
            options: {
                name: 'SourcingCard',
                inputs: [
                    {
                        name: 'items',
                        type: 'list',
                        required: false,
                        subFields: [
                            { name: 'id', type: 'number' },
                            { name: 'sellerId', type: 'number' },
                            { name: 'sellerName', type: 'text' },
                            { name: 'sellerAvatar', type: 'text' },
                            { name: 'isRisingTalent', type: 'boolean' },
                            {
                                name: 'packages',
                                type: 'list',
                                subFields: [
                                    { name: 'id', type: 'number' },
                                    { name: 'amount', type: 'number' },
                                    { name: 'currency', type: 'text' },
                                ],
                            },
                        ],
                        defaultValue: [
                            {
                                id: 123456,
                                sellerId: 98765,
                                sellerName: 'Test Seller',
                                sellerAvatar: '',
                                isRisingTalent: true,
                                packages: [
                                    { id: 1, amount: 50, currency: 'USD' },
                                    { id: 2, amount: 120, currency: 'USD' },
                                ],
                            },
                        ],
                    },
                    {
                        name: 'overrides',
                        type: 'list',
                        required: false,
                        subFields: [
                            { name: 'sellerId', type: 'number' }, // which seller this applies to
                            { name: 'experience', type: 'text' },
                            { name: 'bio', type: 'text' },
                            {
                                name: 'clients',
                                type: 'list',
                                subFields: [
                                    { name: 'src', type: 'text' }, // logo URL
                                    { name: 'alt', type: 'text' },
                                ],
                            },
                        ],
                        defaultValue: [],
                    },
                    {
                        name: 'uiText',
                        type: 'object',
                        required: false,
                        subFields: [
                            { name: 'subtitle', type: 'text' },
                            { name: 'projectTitle', type: 'text' },
                            { name: 'projectDescription', type: 'text' },
                            { name: 'clientsLabel', type: 'text' },
                            { name: 'ctaNote', type: 'text' },
                        ],
                        defaultValue: {
                            subtitle: 'Fiverr-certified project manager',
                            projectTitle: 'Project planning',
                            projectDescription:
                                'Set up your project for success—from defining goals and budget to sourcing the right freelancers.',
                            clientsLabel: 'Among my clients:',
                            ctaNote: 'You won’t be charged yet',
                        },
                    },
                ],
            },
        },
    ],
};
